"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableParser = void 0;
const app_1 = require("app");
const lists_1 = require("src/lists");
const dictionary_1 = require("../../TableCore/dictionary");
const _1 = require("./");
const softwareStatus = {
    archived: 'OB',
    released: 'RL',
};
var SoftwareStatusTypeEnum;
(function (SoftwareStatusTypeEnum) {
    SoftwareStatusTypeEnum[SoftwareStatusTypeEnum["released"] = 0] = "released";
    SoftwareStatusTypeEnum[SoftwareStatusTypeEnum["archived"] = 1] = "archived";
    SoftwareStatusTypeEnum[SoftwareStatusTypeEnum["other"] = 2] = "other";
})(SoftwareStatusTypeEnum || (SoftwareStatusTypeEnum = {}));
const tableColumns = {
    documents: [
        dictionary_1.tableDictionary.type,
        dictionary_1.tableDictionary.name,
        dictionary_1.tableDictionary.languages,
        dictionary_1.tableDictionary.validFor,
        dictionary_1.tableDictionary.updated,
        dictionary_1.tableDictionary.download,
        dictionary_1.tableDictionary.fileType,
    ],
    drawings: [
        dictionary_1.tableDictionary.type,
        dictionary_1.tableDictionary.name,
        dictionary_1.tableDictionary.languages,
        dictionary_1.tableDictionary.updated,
        dictionary_1.tableDictionary.download,
        dictionary_1.tableDictionary.fileType,
    ],
    software: [
        dictionary_1.tableDictionary.type,
        dictionary_1.tableDictionary.softwareCharacteristic,
        dictionary_1.tableDictionary.name,
        dictionary_1.tableDictionary.version,
        dictionary_1.tableDictionary.languages,
        dictionary_1.tableDictionary.updated,
        dictionary_1.tableDictionary.status,
        dictionary_1.tableDictionary.download,
        dictionary_1.tableDictionary.fileType,
    ],
    approvals: [
        dictionary_1.tableDictionary.type,
        dictionary_1.tableDictionary.name,
        dictionary_1.tableDictionary.approvalAuthority,
        dictionary_1.tableDictionary.languages,
        dictionary_1.tableDictionary.validFor,
        dictionary_1.tableDictionary.download,
        dictionary_1.tableDictionary.expirationDate,
        dictionary_1.tableDictionary.fileType,
    ],
};
class TableParser {
    constructor() {
        this.applyTableRowsLogic = tableData => {
            tableData.rows = (0, _1.getRowsWithFiles)(tableData.rows);
            if (tableData.rows.length && !(0, _1.isValidForInRows)(tableData.rows)) {
                tableData.columns = this.getTableDataWithoutValidForCol(tableData.columns);
            }
        };
        this.getTableDataWithoutValidForCol = columns => columns.filter(column => column.name !== dictionary_1.tableDictionary.validFor);
    }
    ParseTable(selector) {
        const tables = [];
        this.selector = $(selector);
        this.selector.each((i, table) => {
            tables[i] = this.Parse(table);
        });
        return tables;
    }
    Parse(table) {
        const tableData = {
            className: $(table).attr('class'),
            tableCaption: $(table).data('table-caption'),
            columns: [],
            dictionary: {},
            rows: [],
            status: {},
            tableType: getTableType($(table)),
        };
        const downloadTable = (link, tableBodyData) => {
            if (link.length) {
                tableBodyData.downloadUrl = link.attr('href');
                tableBodyData.size = link.text().trim();
            }
        };
        const languageTable = (languages, tableBodyData) => {
            tableBodyData.languages = languages ? languages.trim().split('; ') : [];
        };
        function getTableType(currentTable) {
            const className = currentTable.attr('class');
            if (className.indexOf('documents') !== -1) {
                return 'documents';
            }
            else if (className.indexOf('software') !== -1) {
                return 'software';
            }
            else if (className.indexOf('approvals') !== -1) {
                return 'approvals';
            }
            return 'drawings';
        }
        tableData.dictionary = (0, app_1.transformDictionary)(dictionary_1.tableDictionary, $(table).data('dictionary'));
        const connectionMessage = $(table).data('connection-message');
        if (connectionMessage) {
            tableData.status = {
                message: connectionMessage.Message,
                statusCode: connectionMessage.StatusCode,
            };
        }
        /* columns */
        const columns = $(table).find('thead th, thead td');
        tableColumns[tableData.tableType].forEach((name, index) => {
            tableData.columns.push({
                label: $(columns[index]).text().trim(),
                name,
            });
        });
        /* rows */
        table.querySelectorAll('tbody tr').forEach((item) => {
            const tableBodyData = {};
            const rowParams = app_1.AttrService.data(item, 'row-params');
            if (rowParams) {
                tableBodyData.rowId = rowParams.rowId;
                tableBodyData.docsetId = rowParams.docSetId;
                tableBodyData.isOnUserLanguage = rowParams.isOnUserLanguage;
                tableBodyData.isOnGlobalLanguage = rowParams.isOnGlobalLanguage;
                tableBodyData.segment = rowParams.segment;
            }
            item.querySelectorAll('td').forEach((td, i) => {
                switch (tableData.columns[i].name) {
                    case dictionary_1.tableDictionary.name: // name
                        this.getNameColumnData(td, tableBodyData, tableData.columns[i].name);
                        break;
                    case dictionary_1.tableDictionary.validFor: // validFor
                        tableBodyData.validForList = this.getValidForList(td);
                        tableBodyData.validForGlobal = app_1.AttrService.data(td, 'valid-for-global');
                        tableBodyData[tableData.columns[i].name] = $(td).text().trim();
                        break;
                    case dictionary_1.tableDictionary.updated: // updated
                        // get time & date-time
                        tableBodyData.updatedTimestamp = +new Date($(td).attr('data-updated'));
                        tableBodyData[tableData.columns[i].name] = $(td).text().trim();
                        break;
                    case dictionary_1.tableDictionary.expirationDate:
                        tableBodyData.expirationTimestamp = +new Date($(td).attr('data-updated'));
                        tableBodyData[tableData.columns[i].name] = $(td).text().trim();
                        break;
                    case dictionary_1.tableDictionary.download: // download
                        // get link as size & downloadUrl
                        const link = $(td).find('a');
                        downloadTable(link, tableBodyData);
                        break;
                    case dictionary_1.tableDictionary.status: // status
                        const value = $(td).text().trim();
                        tableBodyData.status = this.getStatusColumnData(value, tableData.dictionary);
                        break;
                    case dictionary_1.tableDictionary.languages: // languages
                        const languages = $(td).text();
                        languageTable(languages, tableBodyData);
                        break;
                    default:
                        // get text
                        tableBodyData[tableData.columns[i].name] = $(td).text().trim();
                        break;
                }
            });
            tableData.rows.push(tableBodyData);
        });
        this.applyTableRowsLogic(tableData);
        return tableData;
    }
    getStatusColumnData(value, dictionary) {
        let status;
        switch (value.toUpperCase()) {
            case softwareStatus.released:
                status = {
                    title: dictionary.released || value,
                    type: SoftwareStatusTypeEnum.released,
                };
                break;
            case softwareStatus.archived:
                status = {
                    title: dictionary.archived || value,
                    type: SoftwareStatusTypeEnum.archived,
                };
                break;
            default:
                status = {
                    title: value,
                    type: SoftwareStatusTypeEnum.other,
                };
                break;
        }
        return status;
    }
    getNameColumnData(td, tableBodyData, name) {
        if (td.children.length) {
            tableBodyData[name] = $(td).find('.name').text().trim();
            // get authority & name
            const authority = $(td).find('.authority');
            if (authority.length) {
                tableBodyData[dictionary_1.tableDictionary.authority] = authority.text().trim();
            }
            // get description & type
            const description = $(td).find('.description');
            if (description.length) {
                tableBodyData[dictionary_1.tableDictionary.description] = description.text().trim();
            }
        }
        else {
            tableBodyData[name] = $(td).text().trim();
        }
        return tableBodyData;
    }
    getValidForList(td) {
        const validForValue = app_1.AttrService.data(td, 'valid-for');
        return Array.isArray(validForValue) ? (0, lists_1.sortAlphabetically)(validForValue) : validForValue;
    }
}
const tableParser = new TableParser();
exports.TableParser = tableParser;
